export const Roulette = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 48 48"
    >
        <path
            className="ico_pri"
            fillRule="evenodd"
            d="M9.98 24c0-7.732 6.268-14 14-14s14 6.268 14 14-6.268 14-14 14-14-6.268-14-14Zm2.041-1h3.014a8.958 8.958 0 0 1 1.975-4.695l-2.12-2.14A11.948 11.948 0 0 0 12.021 23Zm4.297-8.236 2.122 2.143a8.957 8.957 0 0 1 4.54-1.852V12.04a11.945 11.945 0 0 0-6.662 2.723Zm8.662-2.723v3.014a8.958 8.958 0 0 1 4.645 1.935l2.13-2.13a11.948 11.948 0 0 0-6.775-2.819Zm8.186 4.237-2.132 2.132A8.957 8.957 0 0 1 32.925 23h3.014a11.947 11.947 0 0 0-2.773-6.722ZM35.939 25h-3.014a8.957 8.957 0 0 1-1.894 4.593l2.126 2.14A11.948 11.948 0 0 0 35.939 25Zm-4.194 8.15-2.123-2.138a8.957 8.957 0 0 1-4.642 1.933v3.014a11.948 11.948 0 0 0 6.765-2.81Zm-8.765 2.809v-3.014a8.957 8.957 0 0 1-4.59-1.89l-2.132 2.13a11.946 11.946 0 0 0 6.722 2.774Zm-8.14-4.183 2.13-2.13A8.958 8.958 0 0 1 15.035 25H12.02a11.947 11.947 0 0 0 2.819 6.776ZM23.98 17a7 7 0 1 0 0 14 7 7 0 0 0 0-14Z"
            clipRule="evenodd"
        />
        <path
            className="ico_pri"
            d="M22.287 22.675a1.26 1.26 0 1 1 .583-.577l1.11 1.108 1.108-1.106a1.26 1.26 0 1 1 .58.58l-1.107 1.105 1.112 1.11a1.26 1.26 0 1 1-.583.577l-1.11-1.108-1.107 1.104a1.26 1.26 0 1 1-.582-.577l1.108-1.106-1.112-1.11Z"
        />
    </svg>
);
